import { render, staticRenderFns } from "./friends.vue?vue&type=template&id=313e2aa9&scoped=true&"
import script from "./friends.vue?vue&type=script&lang=js&"
export * from "./friends.vue?vue&type=script&lang=js&"
import style0 from "./friends.vue?vue&type=style&index=0&id=313e2aa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313e2aa9",
  null
  
)

export default component.exports